import { render } from "./dialog.html?vue&type=template&id=1ad23ab2&scoped=true&ts=true"
import script from "./dialog.ts?vue&type=script&lang=ts"
export * from "./dialog.ts?vue&type=script&lang=ts"

import "./dialog.scss?vue&type=style&index=0&id=1ad23ab2&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad23ab2"]])

export default __exports__